import cn from 'classnames';
import { useState } from 'react';

const BooleanInputGroup = ({ containerClass = '', legendClass = '', children, legendText }) => {
  const [showOutlineClass, setShowOutlineClass] = useState(true);
  return (
    <fieldset
      onMouseDown={() => setShowOutlineClass(false)}
      onKeyDown={() => setShowOutlineClass(true)}
      className={cn(containerClass, { booleanGroup: showOutlineClass })}
    >
      {legendText !== null && (
        <legend className={legendClass || 'font-semibold'}>{legendText}</legend>
      )}
      {children}
    </fieldset>
  );
};

BooleanInputGroup.propTypes = {
  containerClass: PropTypes.string,
  legendClass: PropTypes.string,
  children: PropTypes.node,
  legendText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default BooleanInputGroup;
